<script lang="ts" setup>
import { ModuleFieldItem, useModule } from "@/stores/module";
import {
  BG_STORY_MODULE_ID,
  RELATION_MODULE_ID,
} from "@/stores/module/moduleMate";
import { Mate, StoryBook } from "@/types/entity";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
const props = defineProps<{
  item: ModuleFieldItem;
}>();

const router = useRouter();
// const isStorySet = ref(false);
// const isRelationShip = ref(false);
const storyBook = ref<StoryBook>();
const mateList = ref<Mate[]>();
const moduleStore = useModule();

onMounted(() => {
  const { moduleId, text, value } = props.item;
  if (moduleId === BG_STORY_MODULE_ID && text === "Story collection") {
    // isStorySet.value = true;
    if (value) {
      storyBook.value = moduleStore.extraEntities.storyBook.find(
        (item) => item.id === Number(value)
      );
    }
  } else if (moduleId === RELATION_MODULE_ID) {
    if (value) {
      const hasMap: Record<number, boolean> = {};
      value.split(",").forEach((v) => {
        hasMap[Number(v)] = true;
      });
      mateList.value = moduleStore.extraEntities.mate.filter(
        (item) => hasMap[item.id]
      );
    }
  }
});

const clickMate = (mate: Mate) => {
  router.push({
    name: "mateHome",
    params: {
      uuid: mate.uuid,
    },
  });
};
</script>

<template>
  <VanCell
    :title="item.displayName"
    :value-class="storyBook || mateList ? 'hidden' : 'text-base-content'"
    title-class="text-base-content/50"
    label-class="text-sm text-base-content"
    disabled
  >
    <template #label>
      <div v-if="storyBook">
        <story-list-item :story="storyBook" />
      </div>
      <div v-else-if="mateList" class="flex flex-wrap gap-2 py-2">
        <div
          v-for="mate in mateList"
          :key="mate.id"
          class="w-[60px] relative flex flex-col gap-1 items-center"
          @click="clickMate(mate)"
        >
          <BaseImg :mate="mate" ratio="3:4" />
          <div class="text-xs line-clamp-1">
            {{ mate.name }}
          </div>
        </div>
      </div>
      <div
        v-else
        class="text-sm text-base-content whitespace-pre-line prose prose-sm same-size"
        v-html="item.value"
      />
    </template>
  </VanCell>
</template>
